import { type ReactNode } from "react";

export interface PageHeadingProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned actions (buttons, links). */
  actions?: ReactNode;
}

/* The page title block. Uses a semantic <h1> sized to the DS h3 scale so the
 * app chrome (breadcrumb) keeps the visual lead. */
export function PageHeading({ title, subtitle, actions }: PageHeadingProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="text-h3 font-semibold text-fg-1">{title}</h1>
        {subtitle && (
          <p className="mt-1 max-w-2xl text-body-sm text-fg-2">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
